import TreeSelectorComponent from '@/components/commons/tree-selector/TreeSelectorComponent.vue'
import { mapActions } from 'vuex'

export default {
    name: 'PersonDialogEnterpriseTabComponent',
    components: {
        TreeSelectorComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // loading del selector de empresas
        loadingEnterprises:  false,
        // selector de empresas
        enterprises: [],
    }),
    computed: {
    },
    created () {
    },
    mounted () {
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        selectorMapper(node) {
            return {
                id: node._id,
                label: node.name
            }
        },
        updateSelected(enterprises) {
            this.model.enterpriseIds = enterprises;
        }
    },
    watch: {
        'model.enterpriseIds':{
            deep: true,
            immediate: true,
            handler: function (newEnterprises) {
                this.$emit('enterpriseSelected', newEnterprises)
            }
        },
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.personDialogEnterpriseTabForm) {
                this.$refs.personDialogEnterpriseTabForm.resetValidation()
            }
        }
    }
}
